import PropTypes from 'prop-types';

export const CartBox = ({ title, className = '', ...props }) => (
  <div className={`cart-box p-3 space-y-3 ${className}`} data-testid="cart-box">
    <h5 className="cart-box__title">{title}</h5>
    {props.children}
  </div>
);

CartBox.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default CartBox;
